import { Dispatch } from 'redux';
import { TGetRootState, TDispatchResult } from 'types/shared';

import {
  saveUserSettings,
  IUserSettingsState,
  IUserSettingsAction,
} from '../userSettings';

export const SET_USER_LOCATION = 'opus/user/user_location/SET_USER_LOCATION';

export default function reducer(
  state: IUserSettingsState,
  action: IUserSettingsAction
): IUserSettingsState {
  switch (action.type) {
    case SET_USER_LOCATION: {
      return action?.payload;
    }
    default:
      return state;
  }
}

export const saveUserLocation = (locationId: string): TDispatchResult<any> => {
  return function (dispatch: Dispatch, getState: TGetRootState): any {
    dispatch({
      type: SET_USER_LOCATION,
      payload: locationId,
    });

    // If getState().userSettings.success.all is false, this means we encountered an error while loading the
    // userSettings endpoint. It's safest not to overwrite this with the current Redux store anymore.
    if (getState().userSettings.success.all) {
      return dispatch(saveUserSettings('userLocation') as any);
    }
    // eslint-disable-next-line no-console
    console.warn(
      'We are not saving a parameter userLocation to the KV store because we could not retrieve them and do not want to run the risk of corrupting data.'
    );
  };
};
